import { render, staticRenderFns } from "./SplitLayout.vue?vue&type=template&id=ffa12d0a&scoped=true&"
import script from "./SplitLayout.vue?vue&type=script&lang=js&"
export * from "./SplitLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplitLayout.vue?vue&type=style&index=0&id=ffa12d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa12d0a",
  null
  
)

export default component.exports